import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-at-school",
  templateUrl: "./at-school.component.html",
  styleUrls: ["./at-school.component.scss"],
})
export class AtSchoolComponent implements OnInit {
  slides: any[] = new Array(3).fill({
    id: -1,
    imageUrl: "",
    title: "",
    subtitle: "",
  });

  ngOnInit(): void {
    this.slides[0] = {
      imageUrl:
        environment.assUrl + "assets/images/homepage/back_to_school01.png",
    };
    this.slides[1] = {
      imageUrl:
        environment.assUrl + "assets/images/homepage/back_to_school02.png",
    };
    this.slides[2] = {
      imageUrl:
        environment.assUrl + "assets/images/homepage/back_to_school03.png",
    };
    this.slides[3] = {
      imageUrl:
        environment.assUrl + "assets/images/homepage/back_to_school04.png",
    };
  }
}
